import { render, staticRenderFns } from "./EventCardBack.vue?vue&type=template&id=a2cd8756&scoped=true&lang=pug&"
import script from "./EventCardBack.vue?vue&type=script&lang=js&"
export * from "./EventCardBack.vue?vue&type=script&lang=js&"
import style0 from "./EventCardBack.vue?vue&type=style&index=0&id=a2cd8756&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2cd8756",
  null
  
)

component.options.__file = "EventCardBack.vue"
export default component.exports